import request  from '@/utils/result'

const userApi = {
  getGuestOrder: 'personapi/guestorder/',
  getMyOrder: 'personapi/done',
  getMyToDo: 'personapi/todo',
  guestOrderCheck: 'personapi/verify',
  getCampus: 'personapi/campus',
  getGate: 'personapi/gate',
  getqr: 'personapi/qr',
  saveguest: 'personapi/guestinout',
  queryGuestOrderPage: 'personapi/orderpage',
  guestInvite: 'personapi/guestinvite',
  getJsapiSignature: 'personapi/getcpagentjsapisignature',
  saveFreeverify: 'personapi/freeverify',
  guestOrderabort:'personapi/guestorderabort',
  getGuestTypeDetail: "/api/guestuser/visitortype"
  }
  // 获取业务类型详情
export function getGuestTypeDetail (parameter) {
    return request(
      userApi.getGuestTypeDetail,
       'get',
       parameter
    )
  }
  // 中止申请
  export function guestOrderabort (parameter) {
    return request(
      userApi.guestOrderabort,
       'post',
       {},
       {params: parameter}
    )
  }
  // 获取签名
  export function saveFreeverify (parameter) {
    return request(
      userApi.saveFreeverify,
       'post',
       {},
       {params: parameter}
    )
  }
  // 获取签名
  export function getJsapiSignature (parameter) {
    return request(
      userApi.getJsapiSignature,
       'post',
       parameter
    )
  }
  // 创建邀请函
  export function saveGuestInvite (parameter) {
    return request(
      userApi.guestInvite,
       'post',
       parameter
    )
  }
  // 获取邀请函
  export function getGuestInvite (parameter) {
    return request(
      userApi.guestInvite,
       'get',
       parameter
    )
  }
  // 获取预约记录
  export function queryGuestOrderPage (parameter) {
    return request(
      userApi.queryGuestOrderPage,
       'get',
       parameter
    )
  }
  // 保存信息
  export function saveGuest (parameter) {
    return request(
      userApi.saveguest,
       'post',
       {},
       {params:parameter}
    )
  }
  // 获取人员信息
  export function getqr (parameter) {
    return request(
      userApi.getqr,
       'get',
       parameter
    )
  }
  // 获取校门
  export function getGate (parameter) {
    return request(
      userApi.getGate,
       'get',
       parameter
    )
  }
  // 获取校区
  export function getCampus (parameter) {
    return request(
      userApi.getCampus,
       'get',
       parameter
    )
  }
  export function guestOrderCheck (parameter) {
    return request(
       userApi.guestOrderCheck,
       'post',
       parameter
    )
  }
  export function getMyToDo (parameter) {
    return request(
      userApi.getMyToDo,
       'get',
       parameter
    )
  }
  export function getGuestOrderDetail (parameter) {
    return request(
       userApi.getGuestOrder + parameter,
       'get',
    )
  }
  export function getMyOrder (parameter) {
    return request(
       userApi.getMyOrder,
       'get',
       parameter
    )
  }